// Bayi.jsx
import React from 'react';
import { Box } from "@mui/material";
import UnderConstruction from '../../components/UnderConstruction.jsx';
import NotFound from '../../components/NotFound.jsx';
import UserManagement from '../users/UserManagement.jsx'

export const Dealer = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: 3,
        bgcolor: "#f4f6f8",
        height: "100vh",
        display: 'flex',  // Flex container yapıyoruz
        alignItems: 'center',  // Dikey merkezleme
        justifyContent: 'center'  // Yatay merkezleme
      }}
    >
      <UserManagement/>
      {/* <UnderConstruction /> */}
    </Box>
  );
};

export default Dealer;